import React from 'react';
import AllBooks from '../components/AllBooks';
import AddBook from '../components/AddBook';

const Books = () => (
  <>
    <AllBooks />
    <AddBook />
  </>
);

export default Books;
